import { Flex, Grid, Spinner, Text } from "@chakra-ui/react"

import Layout from 'components/ManagerLayout'
import ActiveLives from "./charts/ActiveLives"
import InactiveLives from "./charts/InactiveLives"
import FinishedForms from "./charts/FinishedForms"
import BirthComparasion from "./charts/BirthComparasion"
import FormsComparasion from "./charts/FormsComparasion"
import InitialFormsComparasion from "./charts/InitialFormsComparasion"
import SecondQuarterFormsComparasion from "./charts/SecondQuarterFormsComparasion"
import ThirdQuarterFormsComparasion from "./charts/ThirdQuarterFormsComparasion"
import AfterBirthFormsComparasion from "./charts/AfterBirthFormsComparasion"
import LateAfterBirthFormsComparasion from "./charts/LateAfterBirthFormsComparasion"
import PregnantRisk from "./charts/PregnantRisk"
import AfterBirthRisk from "./charts/AfterBirthRisk"
import LateAfterBirthRisk from "./charts/LateAfterBirthRisk"
import { useGetOperationalDashboard, useLazyGetOperationalDashboard } from "hooks/useOperationalDashboard"
import Filters from "./Filters"
import { DashboardFilters } from "interfaces/dashboards"
import { useSelector } from "react-redux"
import DashboardLoader from "components/DashboardLoader"
import { State } from "state/reducers"
import ActiveLivesComparasion from "./charts/ActiveLivesComparasion"

const Operational = () => {
    const { operationalDashboard: dashboardData } = useSelector(({ dashboards }: State) => dashboards)

    const { loading } = useGetOperationalDashboard();
    const [filterDashboard, { loading: reloading }] = useLazyGetOperationalDashboard();

    const onFilter = (filters: DashboardFilters = {}) => {
        filterDashboard({
            variables: {
                ...filters
            }
        })
    }

    const isLoading = loading || reloading;

    return (
        <Layout>
            <Filters onFilter={onFilter} />
            {
                isLoading ?
                    <DashboardLoader />
                    :
                    <Grid
                        w="full"
                        templateColumns="repeat(3, 1fr)"
                        templateRows="repeat(1, 1fr)"
                        gap="16px"
                        mb="16px"
                    >
                        <ActiveLivesComparasion data={[dashboardData.activeLives, dashboardData.inactiveLives]} />
                        {/* <BirthComparasion data={dashboardData.birthComparasion} /> */}
                        {/* <FinishedForms data={dashboardData.finishedForms} /> */}
                        <FormsComparasion data={dashboardData.formsComparasion} />
                        <PregnantRisk data={dashboardData.pregnantRisk} />
                        <InitialFormsComparasion data={dashboardData.initialFormsComparasion} />
                        <SecondQuarterFormsComparasion data={dashboardData.secondQuarterFormsComparasion} />
                        <ThirdQuarterFormsComparasion data={dashboardData.thirdQuarterFormsComparasion} />
                        {/* <AfterBirthFormsComparasion data={dashboardData.afterBirthFormsComparasion} />
                        <AfterBirthRisk data={dashboardData.afterBirthRisk} />
                        <LateAfterBirthFormsComparasion data={dashboardData.lateAfterBirthFormsComparasion} />
                        <LateAfterBirthRisk data={dashboardData.lateAfterBirthRisk} /> */}
                    </Grid>
            }
        </Layout>
    )
}

export default Operational